import React, { useMemo, useState } from "react";
import styles from "../Reports/report.module.css";
import SlideBox from "../../common/SlideBox/SlideBox";
import { useSelector } from "react-redux";
import { toolUIIconMap } from "../../Privillages/ToolsRegistry";

const ToolsSection = () => {
  const [flag, setFlag] = useState(false);
  const [report, setReport] = useState("");

  const { catalog = {}, allowed = [] } = useSelector(
    (state) => state.userPrivileges
  );

  const userPrivilegeIdSet = new Set(allowed);

  const mergedToolList = useMemo(() => {
    const allSubs = [];
    Object.values(catalog).forEach((mod) => {
      if (mod?.sub) allSubs.push(...mod.sub);
    });
    return Array.from(new Set(allSubs));
  }, [catalog]);

  const toolOrderMap = useMemo(() => {
    const map = {};
    toolUIIconMap.forEach((item, index) => {
      map[item.accessorKey] = index;
    });
    return map;
  }, []);

  const sortedTools = useMemo(() => {
    return mergedToolList
      .filter((sub) => toolOrderMap[sub] !== undefined)
      .sort((a, b) => toolOrderMap[a] - toolOrderMap[b]);
  }, [mergedToolList, toolOrderMap]);

  const onToggle = (key) => {
    setReport(key);
    setFlag((v) => !v);
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="card card-inverse card-primary text-center">
          <div className="card-body pb-1">
            <SlideBox flag={flag} toggleRightBar={onToggle}>
              {(() => {
                const activeTool = toolUIIconMap.find(
                  (t) => t.detailKey === report
                );
                return activeTool?.component
                  ? React.createElement(activeTool.component, {
                      type1: report,
                      toggleRightBar: onToggle,
                    })
                  : null;
              })()}
            </SlideBox>

            <div className="row text-center text-lg-start">
              {sortedTools?.map((sub, idx) => {
                const subId =
                  catalog?.Tools?.idMap?.[sub] ||
                  catalog?.["Tools Hold & Deposit"]?.idMap?.[sub] ||
                  catalog?.["Tools Others"]?.idMap?.[sub] ||
                  catalog?.["Tools User Management"]?.idMap?.[sub] ||
                  catalog?.["Tools Withdraw"]?.idMap?.[sub];

                const matched = toolUIIconMap?.find(
                  (item) => item?.accessorKey === sub
                );

                if (!userPrivilegeIdSet.has(subId) || !matched) return null;

                return (
                  <div
                    key={matched?.detailKey || idx}
                    className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["report-icon"]}`}
                  >
                    <div
                      className="d-flex flex-column justify-content-center align-items-center"
                      onClick={() => onToggle(matched?.detailKey)}
                    >
                      <img
                        className="img-fluid img-thumbnail"
                        src={matched?.icon || "/images/default-icon.png"}
                        alt=""
                      />
                      <h5 className="mt-3 text-primary text-md text-sm">
                        {matched?.title}
                      </h5>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolsSection;
